import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, SparklesIcon, ShieldIcon, CrownIcon } from 'lucide-react';
interface ServicesProps {
  onBookClick: () => void;
}
const services = [{
  name: 'Precision Cut',
  price: '£25',
  duration: '45 min',
  description: 'Expert scissor work tailored to your style',
  icon: ScissorsIcon
}, {
  name: 'Skin Fade',
  price: '£30',
  duration: '60 min',
  description: 'Seamless gradient fade with precision',
  icon: SparklesIcon
}, {
  name: 'Beard Sculpt',
  price: '£15',
  duration: '30 min',
  description: 'Professional beard shaping and grooming',
  icon: ShieldIcon
}, {
  name: 'Full Experience',
  price: '£40',
  duration: '90 min',
  description: 'Complete transformation package',
  icon: CrownIcon
}];
export function Services({
  onBookClick
}: ServicesProps) {
  return <section id="services" className="py-32 px-6 bg-matte-black" data-id="element-189">
      <div className="max-w-7xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-191">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-off-white mb-4" data-id="element-192">
            Our Services
          </h2>
          <p className="font-inter text-lg text-off-white/60" data-id="element-193">
            Crafted experiences for the modern gentleman
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-194">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.name} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -10,
            rotateX: 5,
            rotateY: 5,
            transition: {
              duration: 0.3
            }
          }} style={{
            perspective: 1000
          }} className="bg-gradient-to-br from-deep-green/20 to-matte-black border border-off-white/10 rounded-2xl p-8 hover:border-soft-gold/50 transition-all" data-id="element-195">
                <div className="mb-6" data-id="element-196">
                  <Icon className="text-soft-gold" size={40} strokeWidth={1.5} data-id="element-197" />
                </div>

                <h3 className="font-playfair text-2xl font-bold text-off-white mb-2" data-id="element-198">
                  {service.name}
                </h3>

                <p className="font-inter text-off-white/60 text-sm mb-4" data-id="element-199">
                  {service.description}
                </p>

                <div className="flex items-center justify-between mb-6" data-id="element-200">
                  <span className="font-playfair text-3xl text-soft-gold font-bold" data-id="element-201">
                    {service.price}
                  </span>
                  <span className="font-inter text-sm text-off-white/60" data-id="element-202">
                    {service.duration}
                  </span>
                </div>

                <motion.button onClick={onBookClick} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full py-3 rounded-full border border-soft-gold text-soft-gold font-inter font-semibold hover:bg-soft-gold hover:text-matte-black transition-all" data-id="element-203">
                  Book Now
                </motion.button>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}